import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { api } from '../api/client'
import { trackUiEvent } from '../analytics'

// Разбор query-параметров OAuth-возврата (?oauth=success|error) и показ баннера.
// Вынесено из layout, чтобы Dashboard не разрастался в «god-компонент».
// onAuthenticated — колбэк для обновления пользователя после успешного OAuth.
export function useOAuthBanner (onAuthenticated) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [banner, setBanner] = useState(null) // 'success' | 'error' | null
  const [bannerMsg, setBannerMsg] = useState('')

  useEffect(() => {
    const oauth = searchParams.get('oauth')
    if (!oauth) return

    if (oauth === 'success') {
      const connector = searchParams.get('connector') || 'amocrm'
      setBanner('success')
      setBannerMsg(connector === 'bitrix24' ? 'Bitrix24' : 'amoCRM')
      trackUiEvent('source_connect_succeeded', { connector_slug: connector })
      api.me().then(data => onAuthenticated && onAuthenticated(data.user)).catch(() => {})
    } else if (oauth === 'error') {
      const connector = searchParams.get('connector') || 'unknown'
      setBanner('error')
      setBannerMsg(searchParams.get('message') || 'Неизвестная ошибка')
      trackUiEvent('source_connect_failed', { connector_slug: connector })
    }

    // Убираем oauth-параметры из URL через replace — не засоряя back-stack.
    const next = new URLSearchParams(searchParams)
    next.delete('oauth')
    next.delete('connector')
    next.delete('message')
    setSearchParams(next, { replace: true })
  }, [])

  return { banner, bannerMsg, dismiss: () => setBanner(null) }
}
